import { create } from "zustand"
import type { FixturePresetId } from "@/shared/dev/fixtures/demoFixturePresets"

export interface DemoModeConfig {
  fixturePresetId: FixturePresetId
  meUserId: string
  initialBalanceTon: string
  onlineCount: number
}

interface DemoModeState {
  active: boolean
  config: DemoModeConfig | null
  replayNowMs: number | null
  activate: (config: DemoModeConfig) => void
  deactivate: () => void
  setReplayNowMs: (ms: number | null) => void
}

export const useDemoModeStore = create<DemoModeState>((set) => ({
  active: false,
  config: null,
  replayNowMs: null,
  activate: (config) => set({ active: true, config, replayNowMs: null }),
  deactivate: () => set({ active: false, config: null, replayNowMs: null }),
  setReplayNowMs: (ms) => set({ replayNowMs: ms }),
}))
